import { render } from "./carrierCard.vue?vue&type=template&id=4f6cfd99&scoped=true"
import script from "./carrierCard.vue?vue&type=script&lang=js"
export * from "./carrierCard.vue?vue&type=script&lang=js"

import "./carrierCard.vue?vue&type=style&index=0&id=4f6cfd99&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f6cfd99"]])

export default __exports__